import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TimetableModalPage } from './timetable-modal';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		TimetableModalPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(TimetableModalPage),
	],
})
export class TimetableModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/timetable-modal/timetable-modal.module.ts